import actionType from '../constants/constants'

export function UpdateFavorites(updatedValue) {

	return dispatch => {
		dispatch({ type: actionType.UPDATEFAVORITES, payload: updatedValue });
	}

}